module.exports = __webpack_public_path__ + "static/media/onboarding_coursier_step3.e251846d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/onboarding/onboarding_coursier_step3.svg
// module id = 1212
// module chunks = 0